@use "../../styles/breakpoint.module.scss" as *;

.contents {
    display: contents;
}

.content {
    display: flex;
    flex-direction: column;
    gap: var(--spacer-16);
}

.hideBodyOnMobile {
    @media ($below-mobile) {
        .body {
            display: none;
        }
    }
}

.imageBlock {
    display: block;
    width: var(--image-width, 100%);
    max-width: var(--image-max-width, none);

    img {
        width: 100%;
        height: auto;
        display: block;
    }
}

.gridContainer {
    composes: gridContainer from "../../styles/composable/layout.module.css";
}

.width12 {
    --grid-column-start: 1;
    --grid-column-end: span 12;
}

.width10 {
    --grid-column-start: 2;
    --grid-column-end: span 10;
}

.width8 {
    --grid-column-start: 3;
    --grid-column-end: span 8;
}

.width6 {
    --grid-column-start: 4;
    --grid-column-end: span 6;
}

.width10,
.width8,
.width6 {
    // Current assumption: if text align is left and there's container width
    // stuff happening, align the content to the left of the container as well.
    // If this ever gets pulled out, consider consolidating the start/end
    // custom properties into `--grid-column`.
    &.left {
        --grid-column-start: 1;
    }

    @media ($below-tablet) {
        --grid-column-start: 1;
        --grid-column-end: -1;
    }
}

.gridInner {
    grid-column: var(--grid-column-start) / var(--grid-column-end);

    @media ($below-mobile) {
        grid-column: 1 / -1;
    }
}

.eyebrow {
    letter-spacing: 0.1em;
    text-transform: uppercase;
}

.eyebrowSmall {
    composes: eyebrow;
    font: var(--font-eyebrow-12);
}

.eyebrowLarge {
    composes: eyebrow;
    font: var(--font-eyebrow-14);
}

.eyebrowAccent {
    color: var(--accent);
}

// Set to block so it respond to text-align; almost everything else is
// a hacky replacement of flex gap
.ctaGroup {
    --cta-gap: var(--spacer-16);
    // left-flush correction; set by left/none alignment below
    --cta-edge: 0;

    display: block;
    margin-top: calc(var(--spacer-8) - var(--cta-gap));
    margin-inline: var(--cta-edge);

    & > * {
        margin-top: var(--cta-gap);
        margin-inline: calc(var(--cta-gap) / 2);
    }
}

.left,
.none {
    visibility: inherit;

    // Pull the row flush to the left edge, cancelling the leading button's
    // half-gap. Centered alignment keeps the symmetric half-gaps so the row
    // stays centered, so the correction only applies here.
    .ctaGroup {
        --cta-edge: calc(var(--cta-gap) / -2);
    }
}

.center {
    text-align: center;

    .body p {
        margin-inline: auto;
    }

    .imageBlock {
        margin-inline: auto;
    }
}

// Content size presets
// Manually curated from poking around Figma designs
.xxl {
    .heading {
        font: var(--font-h-104);
    }

    .body :where(p, li) {
        font: var(--font-p-20);
    }
}

.xl {
    .heading {
        font: var(--font-h-80);
    }

    .body :where(p, li) {
        font: var(--font-p-18);
    }
}

.l {
    .heading {
        font: var(--font-h-64);
    }

    .body :where(p, li) {
        font: var(--font-p-18);
    }
}

.md {
    .heading {
        font: var(--font-h-48);
    }

    .body :where(p, li) {
        font: var(--font-p-18);
    }
}

.sm {
    .heading {
        font: var(--font-h-40);
    }

    .body :where(p, li) {
        font: var(--font-p-18);
    }
}

.xs {
    .heading {
        font: var(--font-h-32);
    }

    .body :where(p, li) {
        font: var(--font-p-18);
    }
}
